// Развертывание текста на главной
itsoftApp.createModule("toggleInformation", function() {

    $(document).on("click", ".info-box-toggle__container", function() {
        $(this).toggleClass("is-active");
        $(this).find(".info-box-toggle__title").toggleClass("is-active");
        $(".info-box").slideToggle();
    });

});
